import { render } from "./detail.vue?vue&type=template&id=b3b262aa&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=b3b262aa&lang=less&scoped=true"

import exportComponent from "E:\\a工互\\vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3b262aa"]])

export default __exports__